import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DepartmentServiceService {
  constructor(private http: HttpClient) {}
  getAllDepartment(): Observable<any> {
    return this.http.get(`${environment.api_endpoint}/departments`);
  }
}
